import { render, staticRenderFns } from "./LoginBackground.vue?vue&type=template&id=2bb7da3a&scoped=true&"
import script from "./LoginBackground.vue?vue&type=script&lang=js&"
export * from "./LoginBackground.vue?vue&type=script&lang=js&"
import style0 from "./LoginBackground.vue?vue&type=style&index=0&id=2bb7da3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7da3a",
  null
  
)

export default component.exports